"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTile = function SvgTile(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.359 3.707 9.01 6.36 6.36 9.011 3.707 6.359zm11.434.001 2.651 2.651-2.651 2.652-2.652-2.652zM6.359 9.407 9.01 12.06l-2.65 2.651-2.652-2.652zm11.434.001 2.651 2.651-2.651 2.652-2.652-2.652zm-5.734-5.701L9.407 6.36l2.653 2.65 2.65-2.65-2.65-2.653zm0 5.7L9.407 12.06l2.652 2.651 2.651-2.651-2.651-2.652zm-5.7 5.7L9.01 17.76l-2.65 2.651-2.652-2.652zm11.434.001 2.651 2.651-2.651 2.652-2.652-2.652zm-5.734-.001L9.407 17.76l2.652 2.651 2.651-2.651-2.651-2.652z",
    stroke: "#4A4A4A",
    fill: "none"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTile);
var _default = exports["default"] = Memo;